<template>
	<vue-datepicker-local

	class="cs-datepicker"

	:disabledDate="disabledDate"
	:inputClass="'cs-datepicker__input'"
	:format="'DD.MM.YYYY'"
	:local="local"
	v-model="real_value" />
</template>

<script>

import VueDatepickerLocal from 'vue-datepicker-local'
import forEach from 'lodash/forEach';

export default {
	name: 'Datepicker',
	components: {
	    VueDatepickerLocal
	},
	data() {
		return {
			real_value: new Date(),
            local: {
				dow: 0, // Sunday is the first day of the week
				hourTip: this.$t('Select Hour'), // tip of select hour
				minuteTip: this.$t('Select Minute'), // tip of select minute
				secondTip: this.$t('Select Second'), // tip of select second
				yearSuffix: '', // suffix of head year
				monthsHead: this.$t('January_February_March_April_May_June_July_August_September_October_November_December').split('_'), // months of head
				months: this.$t('Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec').split('_'), // months of panel
				weeks: this.$t('Su_Mo_Tu_We_Th_Fr_Sa').split('_'), // weeks,
				cancelTip: this.$t('Cancel'),
				submitTip: this.$t('Confirm')
            }
		};
	},
	watch: {
		value(newValue, oldValue) {
			this.real_value = newValue;
		},
		real_value(newValue, oldValue) {
			if(newValue != oldValue){
				this.$emit('input', newValue);
				this.$emit('change', newValue);
			}
		}
	},
	props: {
		mindate: {
			default: false
		},
		maxdate: {
			default: false
		},

		disabled_dates: {
			default() {
				return [];
			}
		},

		value: {
			default: new Date()
		},
	},
	mounted(){
		// @todo das datum kann inital falsch gesetzt werden
		this.real_value = this.value;
	},
	methods: {
		disabledDate (time, format) {
			var daytime = time,
				mindate = (this.mindate ? new Date(this.mindate.getTime()) : false),
				maxdate = (this.maxdate ? new Date(this.maxdate.getTime()) : false);
			daytime.setHours(0,0,0,0);
			if(mindate) mindate.setHours(0,0,0,0);
			if(maxdate) maxdate.setHours(0,0,0,0);



			// wenn das mindate defineirt ist
			// und wenn die gegebenezeit kleiner ist als das mindate
			//
			// mindate wird hier auf 0 uhr des tages eingestellt
			if(mindate && daytime.getTime() < mindate.getTime()) {
				if(daytime.getDate() > 19 && daytime.getDate() < 22){
					//console.log('dat', daytime, daytime.getTime(),  daytime.getTime() < mindate.getTime());
					//console.log('min', mindate, mindate.getTime());
				}
				return true;
			}

			// wenn das maxdate defineirt ist
			// und wenn die gegebenezeit größer ist als das maxdate
			//
			// maxdate wird hier auf 0 uhr des tages eingestellt
			if(maxdate && daytime.getTime() > maxdate.getTime()) return true;


			var isDisabled = false;

			forEach(this.disabled_dates, (obj) => {
				var tmp = new Date(obj.date);
				if(daytime.getTime() === tmp.getTime()) isDisabled = true;
			});
			if(isDisabled) return true;


			return false;
        }
	}
}
</script>


<style lang="scss">

@import '../../styles/config';

$cs-datepicker-input-font-color: #333 !default;
$cs-datepicker-input-hover-font-color: #777 !default;

$cs-datepicker-font-color: #333 !default;
$cs-datepicker-hover-font-color: #777 !default;
$cs-datepicker-out-font-color: #999 !default;

$cs-datepicker-date-color: $cs-datepicker-font-color !default;
$cs-datepicker-date-background-color: #fff !default;
$cs-datepicker-date-active-color: #fff !default;
$cs-datepicker-date-active-background-color: $turquoise !default;
$cs-datepicker-date-hover-color: #fff !default;
$cs-datepicker-date-hover-background-color: $turquoise !default;

.cs-datepicker {
	width: 100%;

	/**
	 * * * * * * * * * INPUT STYLING
	 */
	&:before {
		display: none !important;
	}
	&:after {
	    @extend %__chevron-all;
		content: "\e910";
	    margin-right: -15px;
		color:$primary;
		position: absolute;
		right: 30px;
     	top: 16px;
	}

    &__input,
    > input {
    	cursor: pointer;
	    font-size: 1.125rem !important;
    	line-height: 1.5 !important;

		background-color: #fff !important;
		margin-top:4px !important;
		min-width:188px !important;

		text-align:left !important;
		border: 1px solid transparent !important;
	    padding: 11px 30px !important;
	    border-radius: 25px ;
		height: auto !important;
		font-weight: 300;
		color: $cs-datepicker-input-font-color;
		transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
		&:hover {
			color: $cs-datepicker-input-hover-font-color;
		}

    }

	/**
	 * * * * * * * * * POPUP STYLING
	 */

	.calendar-head a:hover{
		color: $cs-datepicker-hover-font-color;

	}

	a.calendar-prev-decade-btn,
	a.calendar-prev-year-btn,
	a.calendar-prev-month-btn,
	a.calendar-year-select,
	a.calendar-year-select,
	a.calendar-month-select,
	a.calendar-next-month-btn,
	a.calendar-next-year-btn,
	a.calendar-next-decade-btn {
		color: $cs-datepicker-font-color;
	}


	.calendar-head a:hover {
		color: $cs-datepicker-date-hover-background-color;

	}

	a.calendar-date {
    	color: $cs-datepicker-date-color;
    	background-color: $cs-datepicker-date-background-color;
    	&:hover {
    		color: $cs-datepicker-date-hover-color;
    		background-color: $cs-datepicker-date-hover-background-color;
    		font-weight: bold;
    		border-radius: 45px;
    	}
    }

    a.calendar-week{
    	color: $cs-datepicker-date-color;
    	background-color: $cs-datepicker-date-background-color;
    	&:hover {
    		color: $cs-datepicker-date-color;
    		background-color: $cs-datepicker-date-background-color;
    	}

    }

    a.calendar-date-selected {
		color: $cs-datepicker-date-active-color;
		background-color: $cs-datepicker-date-active-background-color;
		border-radius: 45px;
    }

	a.calendar-date-out {
		color: $cs-datepicker-out-font-color;
	}

	a.calendar-date-disabled:hover {
		border-radius: 0;
		font-weight: inherit;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Forms/Datepicker.vue